module.exports = __webpack_public_path__ + "img/otherPay.0af1f663.png";